"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Field = Field;
exports.useField = useField;
var _lib = require("@a1s/lib");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
//
// Context
// -------------------------------------------------------------------------------------------------
const Context = /*#__PURE__*/(0, _react.createContext)(undefined);

//
// Main component
// -------------------------------------------------------------------------------------------------
function Field({
  children,
  id
}) {
  const idRef = (0, _react.useRef)(id || (0, _lib.random)());
  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: idRef.current
  }, children);
}

//
// Main hook
// -------------------------------------------------------------------------------------------------

function useField() {
  const id = (0, _react.useContext)(Context);
  return id;
}